import React from 'react'
import Font from '@cred/react-font'
import { Disclosure } from '@cred/react-disclosures-sdk'
import { Collapse } from 'react-collapse'
import PropTypes from 'prop-types'

export const disclaimerContents = {
  'Stearns Lending': <Disclosure required={false} slug="partners-widgets.mortgage-combined.product-tile.stearns" />,
}

const getDisclaimerContent = lenderName => disclaimerContents[lenderName]

const DisclaimerContent = ({ className, lenderName, isOpen }) => (
  <div className={className}>
    <Collapse isOpened={isOpen}>
      <Font className="mt-16" type="bodySmall">{getDisclaimerContent(lenderName)}</Font>
    </Collapse>
  </div>
)

DisclaimerContent.propTypes = {
  className: PropTypes.string,
  lenderName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
}
DisclaimerContent.defaultProps = {
  className: '',
}

export default DisclaimerContent
